<template>
    <div class="login-signup-form">
        <div class="flex toggle">
            <p class="mr-3 pointer" :class="{active : showSignInForm}" @click="showSignInForm = true">Sign in</p>
            <p class="pointer" :class="{active : !showSignInForm}" @click="showSignInForm = false">Register</p>
        </div>

        <div class="signin" v-if="showSignInForm">
            <v-form ref="loginRef" @submit.prevent>
                <label> Email </label>
                <v-text-field
                    :disabled="loader"
                    v-model="username"
                    :rules="appliedRulesEmail"
                    outlined
                    class="input mt-2"
                    placeholder="Enter your brand associated email"
                    />

                <label>Password</label>
                <v-text-field
                    :disabled="loader"
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                    @click:append="showPassword = !showPassword"
                    :rules="appliedRules"
                    outlined
                    class="input mt-2"
                    placeholder="Enter your password"
                    :type="showPassword ? 'text' : 'password'"
                    @keyup.enter="loginWithEmail"
                    />
                <!-- <p @click.prevent style="color : #2F63C7; transform : translateY(-10px);" class="pointer mb-5"> Forgot password? </p> -->

                <button class="green-background" :disabled="loader" @click.prevent="loginWithEmail">
                    Sign in with Email
                    <v-progress-circular v-if="loader" indeterminate color="white" size="13" width="2" class="mb-1 ml-2"/>
                </button>

                <p class="text-center mt-3 pointer" style="color: #474747;" @click="showSignInForm = false">
                    Don't have an account yet?
                </p>
            </v-form>

            <login-with-google :params="params" :onSuccess="signInOrRegisterWithGmail">
                <button class="sign-in-with-gmail flex">
                    <img src="@/assets/FrontPage/GmailIcon.svg" class="mx-5" alt="">
                    Sign in with Gmail
                </button>
            </login-with-google>
        </div>

        <div class="register" v-if="!showSignInForm">
            <login-with-google :params="params" :onSuccess="signInOrRegisterWithGmail">
            <button class="sign-in-with-gmail flex">
                <img src="@/assets/FrontPage/GmailIcon.svg" class="mx-5" alt="">
                Register with Gmail
            </button>
            </login-with-google>
            <p class="text-center mt-3 pointer" style="color: #474747;" @click="showSignInForm = true"> Already have an account? </p>
        </div>

    </div>
</template>

<script>
import API_URL from '../../../helpers/apiUrls'
import accessToken from '../../../helpers/accessToken'
import rules from '../../../helpers/rules'
import axios from 'axios'
import methods from '../../../helpers/methods'
import MoengageEventGenerator from "../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../helpers/moengageEvents";
import MoengageAtrributes from "../../../helpers/moengageAttributes";
export default {
    name : 'loginSignupForm',

    data() {
        return {
            showSignInForm : true,
            username : '',
            password : '',
            showPassword : false,

            isMobile: false,

            params: {
                client_id : '', // Google client ID
                fetch_basic_profile : true
            },

            rules : rules,
            appliedRules : [],
            appliedRulesEmail : [],
            loader : false,
            MoengageIsActive:false
        }
    },
    mounted(){
        this.checkDevices();
    },

    created() {
        this.params.client_id = process.env.VUE_APP_GOOGLE_CLIENT_ID,
        this.MoengageIsActive = process.env.VUE_APP_MOENGAGE_ACTIVE
    },

    methods : {
        // SIGN IN WITH GMAIL/GOOGLE
        signInOrRegisterWithGmail(user) {
            const successHandler = response => {
                if(response.status === 200) {

                    const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.LoginMode]:this.showSignInForm ?"Log In with Gmail" : "Register with Gmail",
                            // [MoengageAtrributes.this.showSignInForm ?LoginResult:SignupResult]:"Success",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.TabName]:this.showSignInForm?"LogIn":"Register",
                        }
                        MoengageEventGenerator(MoengageEvents.LoginPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                    const userData = {
                        name : response.data.user.full_name,
                        avatar : response.data.user.image ? response.data.user.image.medium : '',
                        brandID : response.data.brand ? response.data.brand.id : null,
                        brandName : response.data.brand ? response.data.brand.name : ''
                    }
                    this.$store.dispatch('mainStore/setUserDetails', userData);
                    // if(response.data.brand && process.env.VUE_APP_MOENGAGE_ACTIVE !== 'false'){
                    //         this.getAndSetEmailMoengage(response.data.brand.id,response.data.access);
                    //         window?.Moengage.add_unique_user_id(response.data.brand.id);
                    //         window?.Moengage.add_first_name(response.data.user.full_name);
                            
                    //     }
                    this.handleNavigations(response);
                }
            }

            const errorHandler = error => {

                const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.LoginMode]:this.showSignInForm ?"Log In with Gmail" : "Register with Gmail",
                            // [MoengageAtrributes.this.showSignInForm ?LoginResult:SignupResult]:"failure",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.TabName]:this.showSignInForm?"LogIn":"Register",
                        }
                        MoengageEventGenerator(MoengageEvents.LoginPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                console.log(error);
            }

            const data = {
                token : user.getAuthResponse().id_token,
                provider : 'google'
            }

            this.requestPOST(
                API_URL.loginOrRegister,
                data,
                {},
                successHandler,
                errorHandler
            )
        },

        handleNavigations(response) {
            console.log('handleNavigations',response)
            if(!response.data.brand) {
                this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                this.$router.replace({ name : 'setupProfileDetails' })
                console.log('handleNavigations','setupProfileDetails')
            }
            else {
                this.$store.state.mainStore.user.brand.brandID = response.data.brand.id;
                this.$store.state.mainStore.user.brand.name = response.data.brand.name;
                this.$store.state.mainStore.user.brand.description = response.data.brand.description;
                this.$store.state.mainStore.user.brand.categoryID = response.data.brand.brand_category?.id;
                
                if(response.data.brand.logo_image && response.data.brand.time_line_image) {
                    
                    accessToken.setCredentials( response.data.access,
                                                response.data.refresh,
                                                response.data.brand.id,
                                                response.data.user.full_name,
                                                response.data.user.image ? response.data.user.image.medium : '',
                                                response.data.brand.name,response.data.brand.logo_image.thumbnail);
                    if(response.data.brand.verification_status === 'verified'){
                        this.$router.replace({ name : 'createContent' });
                        console.log('verified','createContent')
                    }
                    else
                        this.$router.replace({ name : 'verifyCurtain' });
                        
                    this.showToast(
                        'You have successfully logged in!'
                    )
                }
                else if(response.data.brand.logo_image && !response.data.brand.time_line_image) {
                    this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                    this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                    this.$router.replace({ name :!this.isMobile ? 'setupProfileTimeline':'setupProfileCoverMobile', params : { brandDetails : response.data.brand } })
                }
                else {
                    this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                    this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                    this.$router.replace({ name : !this.isMobile ?'setupProfileLogo':'setupProfileLogoMobile', params : { brandDetails : response.data.brand } })
                }
            }
        },

        loginWithEmail() {
            this.appliedRules.push(this.rules.required);
            this.appliedRulesEmail.push(this.rules.required);
            this.appliedRulesEmail.push(this.rules.validEmail);

            if(this.$refs.loginRef.validate()) {
                this.loader = true;
                const successHandler = response => {
                    if(response.status === 200) {

                        const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.LoginMode]:"Log In with Email",
                            [MoengageAtrributes.LoginResult]:"Success",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.TabName]:"LogIn"
                        }
                        MoengageEventGenerator(MoengageEvents.LoginPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                        console.log('loginResponse',response)
                        const userData = {
                            name : response.data.user.full_name,
                            avatar : response.data.user.image ? response.data.user.image.medium : '',
                            brandID : response.data.brand ? response.data.brand.id : null,
                            brandName : response.data.brand ? response.data.brand.name : ''
                        }
                        this.$store.dispatch('mainStore/setUserDetails', userData);
                        // if(response.data.brand && process.env.VUE_APP_MOENGAGE_ACTIVE !== 'false' &&typeof window?.Moengage !='undefined'){
                        //     console.log('MoeCalled')
                        //     this.getAndSetEmailMoengage(response.data.brand.id,response.data.access);
                        //     window?.Moengage.add_unique_user_id(response.data.brand.id);
                        //     window?.Moengage.add_first_name(response.data.user.full_name);
                        // }
                        this.handleNavigations(response);
                        this.$refs.loginRef.reset();
                       
                    }
                }

                const errorHandler = error => {

                    const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.LoginMode]:"Log In with Email",
                            [MoengageAtrributes.LoginResult]:"failure",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.TabName]:"LogIn"
                        }
                        MoengageEventGenerator(MoengageEvents.LoginPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                    console.log(error.response);
                    this.loader = false;
                    this.showToast(error.response.data.errors[0].message, "error", 10000)
                }

                const data = {
                    username : this.username,
                    password : this.password
                }

                this.requestPOST(
                    API_URL.loginWithEmail,
                    data,
                    {},
                    successHandler,
                    errorHandler
                )
            }
        },
         getAndSetEmailMoengage(id,token) {
            const successHandler = response => {
                if(response.status === 200) {
                  if(response.data.email)
                     if(process.env.VUE_APP_MOENGAGE_ACTIVE !== "false"&&typeof window?.Moengage !='undefined'){
                        window?.Moengage.add_email(response.data.email);
                    
                     }
                   
                }
            }

            const errorHandler = error => {
                console.log(error);
            }

            const headers = {
                'Authorization' : `Bearer ${token}`,
               
            }
           

            this.requestGET(
                API_URL.getEmail+`?business_id=${id}`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;

    },
    gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
}
}
</script>

<style lang="scss" scoped>

.toggle {
    justify-content: flex-start;
}

.toggle p {
    font-size: 1.2rem;
}

p:not(.active) {
    color: #ABABAB;
}


.input {
    width: 100%;
}

button {
    color: white;
    width: 100%;
    text-align: center;
    letter-spacing: 0.03em;
    height: 53px;
    border-radius: 3px;
    font-weight: bold;
}

.sign-in-with-gmail {
    color: #757575;
    font-size: 16px;
    font-weight: normal;
    background-color: white;
    border: 0.5px solid #474747;
    border-radius: 3px;
}

</style>
